import React from "react";
import { WidgetDetails, Title, BlogImg } from "../../assets/styled/BlogStyle";

const Blog_1 = () => {
  return (
    <>
      <BlogImg
        src="https://res.cloudinary.com/du1euxdon/image/upload/v1677491626/img_ypngqy.jpg"
        alt="blog-1"
      />
      <Title style={{ marginBottom: "0px" }}>
        Why Reliable Plumbing is Necessary?
      </Title>
      <Title>
        What to Look for in Finding the Right Pipes for your Projects
      </Title>
      <WidgetDetails>
        Consider how difficult it would be to begin each day with leaking pipes
        that were causing walls to collapse, causing mold and fungus to grow,
        and clogging sinks and toilets. These problems not only bother you and
        cause disruption to your daily activities, but they also pose a risk to
        your health. The importance of a good plumbing system is then apparent.
        It is essential to have a functioning plumbing system in order to live
        comfortably and stress-free. In this article from RAKtherm Ultimate
        Piping Solutions, we discuss the value of sound plumbing solutions and
        what to consider before installing your space plumbing system to prevent
        unpleasant surprises and problems.
      </WidgetDetails>

      <WidgetDetails>
        The best plumbing solutions are frequently those that you install once
        and then leave there alone. On the other side, a poor plumbing system
        only leads to problems. Therefore, investing in reliable plumbing
        systems is the easiest and most economical course of action. Regular
        maintenance is also necessary to avoid having to spend a lot of money in
        the future.
      </WidgetDetails>

      <Title>The RNP Technology</Title>
      <WidgetDetails>
        The foundation of reliable drainage plumbing solutions is RNP
        technology. It is the most dependable and offers excellent levels of
        mechanical properties. It is one of the most creative methods available
        and provides a safe, leak-free, and permanent junction.
      </WidgetDetails>

      <WidgetDetails>
        The pipes homogeneous middle-layer construction is based on special
        cells to ensure increased mechanical resistance, wherein the inner-layer
        and outer-layer are combined forming like a “sandwich construction” that
        meets the demands for durability, flexibility, and extended service
        life.
      </WidgetDetails>

      <Title>
        The Value of High-Quality Piping Network Connections in Drainage System.
      </Title>
      <WidgetDetails>
        The pipeline systems pipe connecting components are the most fragile and
        accident-prone. Consequently, the connection employed must be of the
        highest caliber. RAKtherm UPVC pipe fittings and connection technologies
        are regarded as the best available todays drainage system due to their
        strength, inability to corrode, and resistance to the development of
        scale. Smooth inside surface that reduces internal friction and ensures
        the free and quick flow of waste fluids.
      </WidgetDetails>
    </>
  );
};

export default Blog_1;
